module.exports = __webpack_public_path__ + "img/CUS_NSerial.fad04031.png";